import { useCallback, useEffect, useRef, useState } from 'react';
import { LayoutSite } from '../components/layout';
import { Header } from '../components/header';
import { get_logs } from '../services/api.service';
import './logs.scss';

/* -------------------------------------------------------------------------------- *\
|                               levelOf
\* -------------------------------------------------------------------------------- */
function levelOf(line: string): 'error' | 'warn' | 'info'
{
    if (/\berror\b/i.test(line)) return 'error';
    if (/\bwarn\b/i.test(line)) return 'warn';
    return 'info';
}
/* -------------------------------------------------------------------------------- *\
|                               LogsPage
\* -------------------------------------------------------------------------------- */
export function LogsPage()
{
    const [lines, setLines] = useState<string[]>([]);
    const [count, setCount] = useState<number>(500);
    const [filter, setFilter] = useState<string>('');
    const [auto, setAuto] = useState<boolean>(true);
    const [autoScroll, setAutoScroll] = useState<boolean>(true);
    const [error, setError] = useState<string>('');
    const [file, setFile] = useState<string>('');

    const contentRef = useRef<HTMLDivElement>(null);

    /* -------------------------------------------------------------------------------- *\
    |                               refresh
    \* -------------------------------------------------------------------------------- */
    const refresh = useCallback(async () =>
    {
        try
        {
            const answer = await get_logs(count);
            setLines(answer.lines);
            setFile(answer.file);
            setError('');
        }
        catch (e: any)
        {
            setError(e?.message || 'unable to fetch logs');
        }
    }, [count]);

    useEffect(() =>
    {
        refresh();
        if (!auto) return;
        const interval = setInterval(refresh, 3000);
        return () => clearInterval(interval);
    }, [refresh, auto]);

    // When auto-scroll is on, pin the view to the bottom (newest lines).
    useEffect(() =>
    {
        const el = contentRef.current;
        if (el && autoScroll) el.scrollTop = el.scrollHeight;
    }, [lines, autoScroll]);

    const shown = filter
        ? lines.filter(l => l.toLowerCase().includes(filter.toLowerCase()))
        : lines;

    return (
        <LayoutSite>
            <div className="logs">
                <Header title="Redirection" />

                <div className="logs__toolbar">
                    <label>
                        Lines
                        <select value={count} onChange={e => setCount(Number(e.target.value))}>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                            <option value={5000}>5000</option>
                        </select>
                    </label>
                    <input
                        className="logs__filter"
                        placeholder="filter..."
                        value={filter}
                        onChange={e => setFilter(e.target.value)}
                    />
                    <label className="logs__auto">
                        <input type="checkbox" checked={auto} onChange={e => setAuto(e.target.checked)} />
                        auto
                    </label>
                    <label className="logs__auto">
                        <input type="checkbox" checked={autoScroll} onChange={e => setAutoScroll(e.target.checked)} />
                        auto scroll
                    </label>
                    <button className="logs__btn" onClick={refresh}>refresh</button>
                    <span className="logs__count">{shown.length} lines</span>
                </div>

                {error && <div className="logs__error">{error}</div>}
                <div className="logs__file">{file}</div>

                <div className="logs__content" ref={contentRef}>
                    {shown.map((line, i) => (
                        <div key={i} className={`logs__line logs__line__${levelOf(line)}`}>{line}</div>
                    ))}
                    {shown.length === 0 && <div className="logs__line logs__line__info">no log lines</div>}
                </div>
            </div>
        </LayoutSite>
    );
}
